"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = CustomOverlayWithString;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _KakaoMap = require("../KakaoMap");

var _Marker = require("../Marker");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; (0, _forEach.default)(_context2 = ownKeys(source, true)).call(_context2, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context3; (0, _forEach.default)(_context3 = ownKeys(source)).call(_context3, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

CustomOverlayWithString.propTypes = {
  content: _propTypes.default.string.isRequired,
  styles: _propTypes.default.array,
  events: _propTypes.default.array,
  lat: _propTypes.default.number,
  lng: _propTypes.default.number
};

function CustomOverlayWithString(_ref) {
  var _this = this;

  var content = _ref.content,
      styles = _ref.styles,
      events = _ref.events,
      lat = _ref.lat,
      lng = _ref.lng,
      restOptions = (0, _objectWithoutProperties2.default)(_ref, ["content", "styles", "events", "lat", "lng"]);

  var _useContext = (0, _react.useContext)(_KakaoMap.KakaoMapContext),
      kakaoMapObj = _useContext.kakaoMapObj,
      map = (0, _map.default)(_useContext);

  var _useContext2 = (0, _react.useContext)(_Marker.MarkerContext),
      marker = _useContext2.marker,
      markerHeight = _useContext2.height;

  var getPosition = (0, _react.useCallback)(function (marker) {
    return {
      overlayLat: marker ? marker.getPosition().getLat() : lat,
      overlayLng: marker ? marker.getPosition().getLng() : lng
    };
  }, [marker]);
  var getOverlayContent = (0, _react.useCallback)(function (marker) {
    return marker ? _react.default.createElement(Container, {
      markerHeight: markerHeight
    }, content) : content;
  }, [marker]);
  var getYAnchor = (0, _react.useCallback)(function (marker) {
    return marker ? 1 : 0.5;
  }, [marker]);
  var overlayState = (0, _react.useMemo)(function () {
    return {
      position: getPosition(marker),
      content: getOverlayContent(marker),
      yAnchor: getYAnchor(marker)
    };
  }, [marker]);

  var applyStyles = function applyStyles(styles) {
    var styleSheet = document.styleSheets[0];
    (0, _forEach.default)(styles).call(styles, function (styleText) {
      return styleSheet.insertRule(styleText);
    });
  };

  var attachEvents = function attachEvents(_ref2) {
    var events = _ref2.events;
    (0, _forEach.default)(events).call(events, function (eventObj) {
      var _Object$entries = (0, _entries.default)(eventObj),
          _Object$entries2 = (0, _slicedToArray2.default)(_Object$entries, 1),
          _Object$entries2$ = (0, _slicedToArray2.default)(_Object$entries2[0], 2),
          eventHandlerName = _Object$entries2$[0],
          eventHandlerFunction = _Object$entries2$[1];

      window[eventHandlerName] = function (target) {
        var _context;

        for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          rest[_key - 1] = arguments[_key];
        }

        return eventHandlerFunction.call.apply(eventHandlerFunction, (0, _concat.default)(_context = [_this, target]).call(_context, rest));
      };
    });
  };

  (0, _react.useEffect)(function () {
    if (!map || !overlayState) return;
    var position = overlayState.position,
        content = overlayState.content,
        yAnchor = overlayState.yAnchor;
    var customOverlay = new kakaoMapObj.maps.CustomOverlay(_objectSpread({
      position: new kakaoMapObj.maps.LatLng(position.overlayLat, position.overlayLng),
      content: content,
      yAnchor: yAnchor
    }, restOptions));
    customOverlay.setMap(map);
    applyStyles(styles);
    attachEvents({
      events: events
    });
    return function () {
      return customOverlay.setMap(null);
    };
  }, [map, overlayState]);
  return null;
}

var Container = _styledComponents.default.div.withConfig({
  displayName: "CustomOverlayWithString__Container",
  componentId: "oaw0d6-0"
})(["position:relative;bottom:", ";"], function (_ref3) {
  var markerHeight = _ref3.markerHeight;
  return markerHeight;
});